export const REFERRAL_SUBMISSION = 'https://telecare.snapforms.com.au/form/gp-patient-documents';
export const FEEDBACK = 'https://telecare.snapforms.com.au/form/telecareconnect-feedback';
export const TERMS_OF_USE = 'https://www.telecare.com.au/terms-of-use';
export const PRIVACY_POLICY = 'https://www.telecare.com.au/privacy-policy';
export const SUPPORTING_DOCUMENTS = 'https://telecare.snapforms.com.au/form/gp-portal---submit-supporting-documents-';
export const PATIENT_DOC = 'https://telecare.snapforms.com.au/form/gp-patient-documents';
